<div *ngIf="!this.isEmptyData()">
  <div class="ui-g">
      <div class="ui-g-12">

          <p-tabView [(activeIndex)]="this.documentViewer.data.viewerData.current_index"
              (onChange)="this.onFileChange(0,$event,'category')"
              styleClass="document-viewer-tab-border document-viewer-pl-0 tab-panel">
              <p-tabPanel *ngFor="let category of this.documentViewer.data.viewerData.data" [header]="category.name" headerStyleClass="notranslate">

                  <p-tabView [(activeIndex)]="category.current_index"
                      (onChange)="this.onFileChange(category.id,$event,'file')">
                      <p-tabPanel *ngFor="let file of category.file_data" [header]="file.name" headerStyleClass="notranslate">


                          <div class="ui-g">
                              <div class="ui-g-12 text-center">
                                  <p>Attached Date : {{file.updated_at|date}}</p>
                                  <p>{{category.current_index+1}} of {{category.file_data.length}}</p>
                                  <p-button type="button" [style]="{'margin-right':'5px'}" (click)="onPrevious()"
                                      label="Previous" class="p-button-lg" icon="pi pi-arrow-left"
                                      [disabled]="category.current_index==0">
                                  </p-button>
                                  <p-button type="button" [style]="{'margin-right':'5px'}" (click)="onNext()"
                                      label="Next" class="p-button-lg" icon="pi pi-arrow-right"
                                      [disabled]="category.current_index==category.file_data.length-1">
                                  </p-button>
                              </div>
                          </div>
                      </p-tabPanel>
                  </p-tabView>

              </p-tabPanel>
          </p-tabView>
      </div>
  </div>

  <div *ngIf="this.documentViewer.data.viewerData.is_visible">



      <!-- <p>Attached Date : {{this.documentViewer.data.viewerData.current_file_data.updated_at|date}}</p> -->
      <div *ngIf="this.documentViewer.data.viewerData.current_file_data.is_pdf">
          <ngx-doc-viewer class="notranslate" [url]="this.documentViewer.data.viewerData.current_file_data.encoded_uri" viewer="url"
              class="document-viewer-pdf">
          </ngx-doc-viewer>
      </div>
      <div *ngIf="!this.documentViewer.data.viewerData.current_file_data.is_pdf">
          <app-image-viewer  class="notranslate" [images]="[this.documentViewer.data.viewerData.current_file_data.encoded_uri]"
              [idContainer]="this.documentViewer.data.viewerData.current_file_data.image_container"
              [loadOnInit]="true">
          </app-image-viewer>
      </div>

  </div>
</div>
<div class="alert alert-danger" *ngIf="this.isEmptyData()">
  No Documents Uploaded.
</div>